import React from 'react'
import {usStates} from '../../data/usStates';
import {
  Input,
} from 'reactstrap';

const StatePicker = props => {
  const {value, name, onChange, invalid} = props

  return (
    <Input type='select' value={value} name={name} onChange={onChange} invalid={invalid}>
      <option value=''>Select state</option>
      {usStates.map(state => <option key={`state_${state.short}`} value={state.short}>{state.long}</option>)}
    </Input>
  )
}

export default StatePicker